import travellerForm from '@/components/frontoffice/form/traveller/form'
import travellerFormationForm from '@/components/formation/form/traveller/form'

export default {
  components: {
    travellerForm,
    travellerFormationForm
  },

  props: {
    duplicate: {
      type: Boolean,
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      bedroomsIndexes: {
        single: 0,
        double: 0
      },
      alreadySelectedTravellers: []
    }
  },

  provide() {
    let newForm = !(this.edit || this.duplicate || this.alreadySelectedTravellers)

    return {
      mustLoad: !newForm,
      bedrooms: this.formData.bedrooms
    }
  },

  methods: {
    setRoomInfos(type) {
      for (let roomOffer of this.formData.roomOffers[type]) {
        let counter = roomOffer.selected
        if (counter) {
          counter--
          return {
            id: roomOffer.id,
            adultCount: roomOffer.room.adultCount,
            offerDetails: roomOffer.offer,
            description: roomOffer.selected.description.split(':')[0]
          }
        }
      }
    },

    initRoomStructure(type) {
      this.formData.bedrooms[type].travellers = []
      let nbRooms = 0

      while (nbRooms < this.formData.bedrooms[type].amount) {
        let temp = { 1: null }

        if (type === 'double') {
          temp[2] = null
          temp.bedType = null
        }
        if (this.formData.roomOffers) temp.roomInfos = this.setRoomInfos(type)

        this.formData.bedrooms[type].travellers.push(temp)

        nbRooms++
        this.bedroomsIndexes[type]++
      }
    },

    initFormDataRooms (nbSingleRooms = 1, nbDoubleRooms = 0, rooms = null) {
      this.formData.bedrooms.single.amount = nbSingleRooms
      this.formData.bedrooms.double.amount = nbDoubleRooms

      this.initRoomStructure('single')
      this.initRoomStructure('double')

      if (rooms) {
        let index = {
          single: 1,
          double: 1
        }

        rooms.forEach(room => {
          this.onChangeTraveller({
            index: index[room.type],
            roomType: room.type,
            value: {
              new: room._traveller1,
              rank: 1
            }
          })

          if (room.type === 'double') {
            this.onChangeTraveller({
              index: index[room.type],
              roomType: room.type,
              value: {
                new: room._traveller2,
                rank: 2
              }
            })

            this.onChangeBedType({
              index: index[room.type],
              roomType: room.type,
              value: room.bedType
            })
          }

          index[room.type]++
        })
      }
    },

    updateFormDataRooms (type, action) {
      if (action === 'add') {
        let temp = { 1: null }
        if (type === 'double') {
          temp[2] = null
          temp.bedType = null
        }
        this.formData.bedrooms[type].travellers.push(temp)
        this.bedroomsIndexes[type]++
      } else if (action === 'minus') {
        this.formData.bedrooms[type].travellers.pop()
        this.bedroomsIndexes[type]--
      }
    },

    onChangeBedType(val) {
      this.formData.bedrooms[val.roomType].travellers[val.index - 1].bedType = val.value
    },

    onChangeTraveller(val) {
      let oldVal = val.value.old
      let newVal = val.value.new
      let rank = val.value.rank

      if (oldVal) {
        // remove from selected travellers
        this.alreadySelectedTravellers = this.alreadySelectedTravellers.filter(function (traveller) {
          return traveller.id !== oldVal.id
        })

        // remove from formData
        this.formData.bedrooms[val.roomType].travellers[val.index - 1][rank] = null
      }

      if (newVal) {
        // add to selected travellers
        this.alreadySelectedTravellers.push(newVal)
        // add to formData
        this.formData.bedrooms[val.roomType].travellers[val.index - 1][rank] = newVal
      }

      // Applied only if this concerns the first traveller of the first displayed room
      let cloneCustomFields = false
      let roomType = val.roomType

      if (val.index === 1) {
        // single is displayed first by default
        if (val.roomType === 'single' && this.bedroomsIndexes.single > 0) { cloneCustomFields = true }

        if (val.roomType === 'double' && this.bedroomsIndexes.single === 0) { cloneCustomFields = true }
      }

      if (cloneCustomFields) this.cloneBookingCustomFieldsFromTraveller(newVal, roomType)
    },

    cloneBookingCustomFieldsFromTraveller(traveller, roomType) {
      if (!traveller) {
        if (this.formData.customFields) {
          this.formData.customFields.forEach((customField) => {
            // On vérifie que la valeur n'est pas vide avant
            if (!customField.read_only && (!customField.value || customField.value === '')) customField.value = ""
          })
        }
      } else {
        // first selected traveller of first room
        let trav = this.formData.bedrooms[roomType].travellers[0][1]

        if (trav.id === traveller.id) {
          // no need to check others, it's been aplied only for the first traveller
          for (let i in this.formData.customFields) {
            if (this.formData.customFields.hasOwnProperty(i)) {
              let customField = this.formData.customFields[i]

              for (let inputField of trav.traveller_input_fields) {
                if (inputField.booking_input_field) {
                  if (customField.id === inputField.booking_input_field.id) {
                    // On vérifie que la valeur n'est pas vide avant
                    if (!customField.read_only && (!customField.value || customField.value === '')) customField.value = inputField.value
                  }
                }
              }
            }
          }
        }
      }
    }
  },

  computed: {
    getRoomTypeClass() {
      let ret = 'offline-travellers__search-form col-12 '

      if (this.context === 'formation') {
        return ret
      }

      return this.formData.bedrooms.single.amount && this.formData.bedrooms.double.amount ? ret += 'col-lg-6' : ret += 'col-lg-6'
    }
  }
}
